"use strict";

var Backbone = require('backbone');
var _ = require('underscore');
var Room = require('./room');
var Bed = require('./bed');

var BedConfiguration = Backbone.Model.extend({
  parse: function (data, restoreSelections) {
    // create sub room and bed elements.
    // Make sure they all have a reference to the bedConfig to pass events upstream
    var self = this;
    var rooms = _(data.rooms).map(function(roomData) {
      var beds = _(roomData.beds).chain().sortBy('label').map(function(bedData) {
        var bed = new Bed(bedData);
        bed.set('bedConfiguration', self);

        return bed;
      }).value();

      var room = new Room(_.defaults({beds: beds}, roomData));
      room.set('bedConfiguration', self);

      // beds must also know in which room they are in
      room.get('beds').forEach(function(bed) {
        bed.set('room', room);
      });

      // restore previously generated state
      if (restoreSelections && !_.isEmpty(roomData.selected)) {
        var selected = roomData.selected;
        var CRIB = 0, SINGLE_AIRBED = 1, DOUBLE_AIRBED = 2;

        // restore crib
        if (selected['num_cribs'] > 0) {
          room.addExtra(CRIB);
        }

        // restore airbeds
        selected.airbeds.forEach(function(airBed) {
          if (airBed.size === "SINGLE") {
            room.addExtra(SINGLE_AIRBED);
          } else { // DOUBLE
            room.addExtra(DOUBLE_AIRBED, airBed['num_guests']);
          }
        });

        // restore beds selections
        _(selected.beds).keys().forEach(function(id) {
          var selectedBed = selected.beds[id];
          var bedModel = _(beds).find(function(bed) {
            return bed.get('id') === id;
          });

          bedModel.set('state', selectedBed.state);
          bedModel.set('selected', selectedBed['num_guests']);
        });
      }

      return room;
    });

    this.set('rooms', rooms, {silent: true});
  },
  isValid: function() {
    return this.getSelectedCount() === this.getTotalGuestsCount();
  },
  setInitalData: function(initalData) {
    this.set('initalData', JSON.stringify(initalData), {silent: true});
  },
  reset: function() {
    var initalData = JSON.parse(this.get('initalData'));

    this.parse(initalData, false);
    this.trigger("reset");
  },
  hasSelection: function() {
    return this.getSelection().length > 0;
  },
  getSelection: function() {
    var rooms = this.get('rooms');

    rooms = rooms.map(function(room) {
      var id = room.get('id');
      var wasCribAdded = room.wasCribAdded();

      var airBeds = room.getAirbeds().map(function(airBed) {
        return {
          'size': airBed.get('size'),
          'num_guests': airBed.getSelectedCount()
        };
      });

      var normalBeds = room.getNormalBeds().map(function(bed) {
        var selected = bed.getSelectedCount();
        var id = bed.get('id');
        var state = bed.getState();

        if (selected === 0) {
          return null; // this bed is unoccupied
        }

        var result = {
          'id': id,
          'num_guests': selected,
        };

        if (state) {
          result.state = state;
        }

        return result;
      }).filter(Boolean); // filter out unoccupied beds

      if (normalBeds.length === 0 && airBeds.length === 0 && wasCribAdded === false) {
        return null; // this room is unoccupied
      }

      var result = {
        'room_id': id,
        'num_cribs': wasCribAdded ? 1 : 0
      };

      if (airBeds.length > 0) {
        result.airbeds = airBeds;
      }
      if (normalBeds.length > 0) {
        result.beds = normalBeds;
      }

      return result;
    }).filter(Boolean); // filter out unoccupied rooms

    return rooms;
  },
  getSelectedCount: function() {
    var sum = 0;

    this.get('rooms').forEach(function(room) {
      room.get('beds').forEach(function(bed) {
        sum += bed.getSelectedCount();
      });
    });

    return sum;
  },
  getSleepsLeft: function() {
    return this.getTotalGuestsCount() - this.getSelectedCount();
  },
  getTotalGuestsCount: function() {
    var additionalGuestsModel = this.get('additionalGuestsModel');
    var totalGuestsCount = this.get('totalGuestsCount');

    if (additionalGuestsModel) {
      return additionalGuestsModel.length + 1;
    } else {
      return totalGuestsCount;
    }
  },
  setAdditionalGuestsModel: function(additionalGuestsModel) {
    this.set('additionalGuestsModel', additionalGuestsModel);
    this.listenTo(additionalGuestsModel, "add remove change", this.reset.bind(this));
  },
  isAdditonalGuestsModelValid: function() {
    return this.get('additionalGuestsModel').every(function(model) {
      return model.isValid();
    });
  },
  setTotalGuestsCount: function(count) {
    this.set('totalGuestsCount', count);
  },
  _sortFloorElements: function(floors) {
    var self = this;
    var floorArray = _(floors).keys().sort().map(function(key) {
      var rooms = floors[key];
      rooms = _(rooms).sortBy(function(room) {
        return room.get('label');
      });

      var label = self._getLabelForFloorNumber(key);

      return {
        rooms: rooms,
        label: label
      };
    });

    return floorArray;
  },
  _getLabelForFloorNumber: function(floorNumber) {
    if (floorNumber === "unkown") {
      return null;
    } else {
      return "Floor " + floorNumber;
    }
  },
  _groupRoomsByFloor: function(rooms) {
    var floors = {};

    rooms.forEach(function(room) {
      var numericFloor = room.get('numeric_floor');
      var index;
      if (numericFloor === null || numericFloor === undefined) {
        index = "unkown";
      } else {
        index = numericFloor;
      }

      floors[index] = floors[index] || [];
      floors[index].push(room);
    });

    return floors;
  },

  getFloors: function() {
    var rooms = this.get('rooms');
    var floors = this._groupRoomsByFloor(rooms);
    floors = this._sortFloorElements(floors);

    return floors;
  },

  sumBillables: function() {
    var rooms = this.get('rooms');
    var sum = 0;

    _(rooms).each(function(room) {
      _(room.get('beds')).each(function(bed) {
        var price = bed.get('price');

        if (price) {
          sum += price;
        }
      });
    });

    return sum;
  }
});

module.exports = BedConfiguration;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/models/bed-configuration.js
 **/